import testUserQueries from '@apis/queries/testUserQueries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

const HJM_ID = '4150468217112520';

function useTestUser(): boolean {
    const { user } = useUser();
    const { status } = useQuery({
        ...testUserQueries.isTestUser(),
        enabled: !!user,
    });
    return status === 'success' || user?.barcodeNo === HJM_ID;
}

export default useTestUser;
